import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card"
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  CartesianGrid,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts"

const commercialeData = [
  { name: "Lun", value: 18 },
  { name: "Mar", value: 24 },
  { name: "Mer", value: 20 },
  { name: "Gio", value: 32 },
  { name: "Ven", value: 28 },
  { name: "Sab", value: 12 },
  { name: "Dom", value: 10 },
]

const legaleData = [
  { day: "Oggi", scadenze: 5 },
  { day: "Domani", scadenze: 7 },
  { day: "+2gg", scadenze: 4 },
  { day: "+3gg", scadenze: 6 },
  { day: "+4gg", scadenze: 3 },
  { day: "+5gg", scadenze: 2 },
  { day: "+6gg", scadenze: 1 },
]

const amministrazioneData = [
  { month: "Gen", incassi: 32000, insoluti: 2400 },
  { month: "Feb", incassi: 28000, insoluti: 3100 },
  { month: "Mar", incassi: 35000, insoluti: 2600 },
  { month: "Apr", incassi: 30000, insoluti: 2200 },
  { month: "Mag", incassi: 38000, insoluti: 2800 },
  { month: "Giu", incassi: 36000, insoluti: 2500 },
]

const coordinamentoData = [
  { name: "Commerciale", value: 45 },
  { name: "Legale", value: 30 },
  { name: "Amministrazione", value: 18 },
  { name: "Contabilità", value: 12 },
  { name: "Coordinamento", value: 20 },
]

const hrData = [
  { month: "Gen", onboarding: 3, uscite: 1 },
  { month: "Feb", onboarding: 5, uscite: 2 },
  { month: "Mar", onboarding: 4, uscite: 1 },
  { month: "Apr", onboarding: 6, uscite: 3 },
  { month: "Mag", onboarding: 7, uscite: 2 },
  { month: "Giu", onboarding: 5, uscite: 1 },
]

const leadSourceData = [
  { day: "Lun", web: 12, campagne: 8, referral: 5, call: 3 },
  { day: "Mar", web: 16, campagne: 10, referral: 6, call: 4 },
  { day: "Mer", web: 14, campagne: 9, referral: 4, call: 5 },
  { day: "Gio", web: 22, campagne: 12, referral: 7, call: 6 },
  { day: "Ven", web: 18, campagne: 11, referral: 5, call: 4 },
  { day: "Sab", web: 9, campagne: 6, referral: 3, call: 2 },
  { day: "Dom", web: 7, campagne: 5, referral: 2, call: 2 },
]

const marketingCampaignData = [
  { campaign: "Brand Search", ctr: 3.2, cpl: 8.9, conversions: 420 },
  { campaign: "Social Ads", ctr: 1.8, cpl: 12.4, conversions: 260 },
  { campaign: "Display Retargeting", ctr: 0.9, cpl: 7.2, conversions: 180 },
  { campaign: "Email Drip", ctr: 4.1, cpl: 5.8, conversions: 520 },
  { campaign: "Partner Referral", ctr: 2.6, cpl: 10.1, conversions: 310 },
]

const pieColors = ["#0ea5e9", "#22c55e", "#6366f1", "#f97316", "#e11d48"]

export function RevenueChart({ variant = "default" }) {
  const normalizedVariant = variant.toLowerCase()

  if (normalizedVariant === "legale") {
    return (
      <Card className="col-span-4 border-none shadow-sm">
        <CardHeader>
          <CardTitle>Scadenze Legali</CardTitle>
          <CardDescription>Udienze e termini nei prossimi 7 giorni</CardDescription>
        </CardHeader>
        <CardContent className="pl-2">
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={legaleData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
              <XAxis dataKey="day" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <Tooltip
                contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
              />
              <Bar dataKey="scadenze" fill="#e11d48" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    )
  }

  if (normalizedVariant === "marketing") {
    return (
      <Card className="col-span-4 border-none shadow-sm">
        <CardHeader>
          <CardTitle>Performance Campagne</CardTitle>
          <CardDescription>CTR, CPL e conversioni per campagna</CardDescription>
        </CardHeader>
        <CardContent className="pl-2">
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={marketingCampaignData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
              <XAxis dataKey="campaign" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <Tooltip contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }} />
              <Legend />
              <Bar dataKey="ctr" fill="#f59e0b" radius={[6, 6, 0, 0]} name="CTR (%)" />
              <Bar dataKey="conversions" fill="#6366f1" radius={[6, 6, 0, 0]} name="Conversioni" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    )
  }

  if (normalizedVariant === "lead") {
    return (
      <Card className="col-span-4 border-none shadow-sm">
        <CardHeader>
          <CardTitle>Fonti Lead</CardTitle>
          <CardDescription>Distribuzione per fonte negli ultimi 7 giorni</CardDescription>
        </CardHeader>
        <CardContent className="pl-2">
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={leadSourceData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
              <XAxis dataKey="day" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <Tooltip contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }} />
              <Legend />
              <Bar dataKey="web" stackId="a" fill="#0ea5e9" radius={[6, 6, 0, 0]} name="Web" />
              <Bar dataKey="campagne" stackId="a" fill="#6366f1" radius={[6, 6, 0, 0]} name="Campagne" />
              <Bar dataKey="referral" stackId="a" fill="#22c55e" radius={[6, 6, 0, 0]} name="Referral" />
              <Bar dataKey="call" stackId="a" fill="#f97316" radius={[6, 6, 0, 0]} name="Chiamate" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    )
  }

  if (normalizedVariant === "amministrazione") {
    return (
      <Card className="col-span-4 border-none shadow-sm">
        <CardHeader>
          <CardTitle>Incassi vs Insoluti</CardTitle>
          <CardDescription>Andamento mensile degli incassi e dei pagamenti insoluti</CardDescription>
        </CardHeader>
        <CardContent className="pl-2">
          <ResponsiveContainer width="100%" height={350}>
            <AreaChart data={amministrazioneData}>
              <defs>
                <linearGradient id="colorIncassi" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#22c55e" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#22c55e" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="colorInsoluti" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#e11d48" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#e11d48" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
              <XAxis dataKey="month" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis
                stroke="#888888"
                fontSize={12}
                tickLine={false}
                axisLine={false}
                tickFormatter={(value) => `€${value / 1000}k`}
              />
              <Tooltip
                contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
              />
              <Area
                type="monotone"
                dataKey="incassi"
                stroke="#22c55e"
                strokeWidth={2}
                fillOpacity={1}
                fill="url(#colorIncassi)"
                name="Incassi"
              />
              <Area
                type="monotone"
                dataKey="insoluti"
                stroke="#e11d48"
                strokeWidth={2}
                fillOpacity={1}
                fill="url(#colorInsoluti)"
                name="Insoluti"
              />
            </AreaChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    )
  }

  if (normalizedVariant === "coordinamento") {
    return (
      <Card className="col-span-4 border-none shadow-sm">
        <CardHeader>
          <CardTitle>Pratiche per Dipartimento</CardTitle>
          <CardDescription>Distribuzione delle pratiche attive tra i dipartimenti</CardDescription>
        </CardHeader>
        <CardContent className="pl-2">
          <ResponsiveContainer width="100%" height={350}>
            <PieChart>
              <Tooltip
                contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
              />
              <Legend />
              <Pie
                data={coordinamentoData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={110}
                innerRadius={60}
                paddingAngle={2}
              >
                {coordinamentoData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    )
  }

  if (normalizedVariant === "risorse umane" || normalizedVariant === "hr") {
    return (
      <Card className="col-span-4 border-none shadow-sm">
        <CardHeader>
          <CardTitle>Onboarding vs Uscite</CardTitle>
          <CardDescription>Trend mensile ingressi e uscite del personale</CardDescription>
        </CardHeader>
        <CardContent className="pl-2">
          <ResponsiveContainer width="100%" height={350}>
            <AreaChart data={hrData}>
              <defs>
                <linearGradient id="colorOnboarding" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#22c55e" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#22c55e" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="colorUscite" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#e11d48" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#e11d48" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
              <XAxis dataKey="month" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
              <Tooltip
                contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
              />
              <Area
                type="monotone"
                dataKey="onboarding"
                stroke="#22c55e"
                strokeWidth={2}
                fillOpacity={1}
                fill="url(#colorOnboarding)"
                name="Onboarding"
              />
              <Area
                type="monotone"
                dataKey="uscite"
                stroke="#e11d48"
                strokeWidth={2}
                fillOpacity={1}
                fill="url(#colorUscite)"
                name="Uscite"
              />
            </AreaChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className="col-span-4 border-none shadow-sm">
      <CardHeader>
        <CardTitle>{normalizedVariant === "commerciale" ? "Lead Settimanali" : "Andamento Pratiche"}</CardTitle>
        <CardDescription>
          {normalizedVariant === "commerciale"
            ? "Volume dei lead gestiti negli ultimi 7 giorni"
            : "Valore pratiche gestite negli ultimi 7 giorni"}
        </CardDescription>
      </CardHeader>
      <CardContent className="pl-2">
        <ResponsiveContainer width="100%" height={350}>
          <AreaChart data={commercialeData}>
            <defs>
              <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#0ea5e9" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#0ea5e9" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="name" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
            <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
            <Tooltip
              contentStyle={{ borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
              cursor={{ stroke: "#0ea5e9", strokeWidth: 1 }}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#0ea5e9"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorTotal)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  )
}
